import { Box, Text } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';
import priceDataHooks from '../Price.datahooks';
import s from './DisplayPrice.scss';
export const InlineDisplayPrice = ({ size, priceLabel, cycleLabel, fullPriceLabel, shouldShowProductFullPrice, }) => {
    return (React.createElement(Box, { className: classNames(s.displayPrice, s[size]), dataHook: priceDataHooks.inlineDisplayPrice, gap: "SP1" },
        React.createElement(Box, { direction: "horizontal", gap: "SP1" },
            shouldShowProductFullPrice && fullPriceLabel !== priceLabel && (React.createElement(Text, { className: classNames(s.integer, s.fullPrice, s.inline, s[size]), dataHook: priceDataHooks.fullPrice, skin: "disabled" }, fullPriceLabel)),
            React.createElement(Text, { className: classNames(s.integer, s.inline, s[size]), dataHook: priceDataHooks.integerPrice }, priceLabel)),
        React.createElement(Box, { className: classNames(s.cycleLabel, s[size]), verticalAlign: "bottom" },
            React.createElement(Text, { size: size, dataHook: priceDataHooks.cycleLabel }, cycleLabel))));
};
//# sourceMappingURL=InlineDisplayPrice.js.map